import { WordPress } from "../../../../wordpress/wordpress_api";
import { CMSState } from "../../../../cms/blocks/types.gen";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { IOWidget, Action, mk_widget } from "widgets-for-react";
import { PublicSiteState } from "../../../../public_site.main.mod";
import React from "react";
import { link, linkWrapper } from "../../../../cms/blocks/utils.gen";
import { ButtonData } from "../../../../wordpress/types_and_parser/extra_types.mod";
import { getImageAttribute } from "../../../utils/extra_images.mod";

export type GridBlockItem2 = {
  title: string
  intro: string
  image?: WordPress.MediaResponse
  has_email_link: boolean
  has_tel_link: boolean
  email_link_url?: string
  email_link_text?: string
  tel_link_text?: string
  tel_link_url?: string
}

export type GridAttributes2 = {
  blockName: 'vidda/grid2'
  title: string
  intro: string
  primary_button?: ButtonData
  secondary_button?: ButtonData
  blocks: Array<GridBlockItem2>
}

export interface GridInterface2 {
  blockName: 'vidda/grid2'
  attrs: GridAttributes2
}

export type GridBlockProps2<extra_images> = GridAttributes2

export type GridBlockStyle2 = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  intro_classname: string
  visual_classname: string
}>

export function GridBlock2<customBlockData, extra_images>(
  props: GridBlockProps2<extra_images>,
  options?: { style: GridBlockStyle2; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: (_) => (
        <section className="block block--grid block--grid-info block--light">
          <div className="block__inner grid--spacing">
            <header className="block__header container--s grid--gutter">
              {props.title && <h2 className="block__title typo--xl">{props.title}</h2>}
              {props.intro && (
                <div className="block__intro text--styled" dangerouslySetInnerHTML={{ __html: props.intro }}></div>
              )}
            </header>

            <div className="block__content">
              <ul className="block__grid grid">
                {props.blocks.map((grid) => (
                  <li className="grid__item">
                    <div className="grid__inner">
                      <div className="grid__content">
                        {grid.title && <h3 className="grid__title typo--m">{grid.title}</h3>}
                        {grid.intro && <p className="grid__intro typo--xs" dangerouslySetInnerHTML={{ __html: grid.intro }} />}
                        <footer className="grid__footer">
                          {grid.has_tel_link || grid.has_email_link ?
                            <div className="grid__clickable grid__clickable--flex">
                              {grid.has_tel_link && grid.tel_link_text && <a className="link link--primary" href={`tel:${grid.tel_link_url}`}>{grid.tel_link_text}</a>}
                              {grid.has_email_link && grid.email_link_text && <a className="link link--primary" href={`mailto:${grid.email_link_url}?subject=Contactverzoek website`}>{grid.email_link_text}</a>}
                            </div>
                            : <></>}
                          {/* You can send the adress to the following gmaps link to create a route direction. The double slash after dir // means that the adres is set as desitnation use single single slash for start point */}
                          {/* <div className="grid__clickable">
                            <a target="_blank" href={`https://www.google.com/maps/dir//${grid.intro.replace(/<br>/g, ' ')}/`} className="link link--primary">Routeomschrijving</a>
                          </div> */}
                        </footer>
                      </div>
                      {grid.image ? (
                        <div className="grid__visual fit-object grid-has-image">
                          <img src={getImageAttribute(grid.image, 'grid', 'source_url')} />
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            {(props.primary_button || props.secondary_button) && (
              <footer className="block__footer container--s grid--gutter">
                {props.primary_button &&
                  link(
                    linkWrapper({ title: props.primary_button.text, url: props.primary_button.url }),
                    { classname: "button button--primary" },
                    props.primary_button.text
                  )}
                {props.secondary_button &&
                  link(
                    linkWrapper({ title: props.secondary_button.text, url: props.secondary_button.url }),
                    { classname: "link link--primary" },
                    props.secondary_button.text
                  )}
              </footer>
            )}
          </div>
        </section>
      ),
    });
  }
}